import React, { useState } from 'react';
import { Headphones } from 'lucide-react';

interface HelpCenterButtonProps {
  onOpenFeedback: () => void;
  isOpen?: boolean;
}

export const HelpCenterButton: React.FC<HelpCenterButtonProps> = ({ onOpenFeedback, isOpen = false }) => {
  const [hovered, setHovered] = useState(false);

  if (isOpen) return null;

  return (
    <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 9999 }}>
      <button
        onClick={onOpenFeedback}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#003f2e',
          borderRadius: '999px',
          border: 'none',
          cursor: 'pointer',
          height: '50px',
          width: hovered ? '145px' : '50px',
          overflow: 'hidden',
          transition: 'width 0.3s ease, box-shadow 0.2s ease',
          boxShadow: hovered
            ? '0 6px 20px rgba(0,63,46,0.45)'
            : '0 4px 16px rgba(0,63,46,0.35)',
          padding: 0,
        }}
        title="Feedback"
      >
        <span
          style={{
            color: '#fff',
            fontSize: '0.875rem',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            paddingLeft: hovered ? '16px' : '0',
            opacity: hovered ? 1 : 0,
            transition: 'opacity 0.2s ease 0.1s',
            flex: 1,
            overflow: 'hidden',
            minWidth: 0,
            textAlign: 'left',
          }}
        >
          Feedback
        </span>
        <div
          style={{
            width: '50px',
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Headphones style={{ width: 22, height: 22, color: '#fff' }} />
        </div>
      </button>
    </div>
  );
};
